import { useEffect, useState } from "react";
import {
    ConsultaData, calcularPrecioFinal, Ruta, TIPO_CAMBIO, moneda_mostrar,
    renderNumero, porcentaje_igv, decodeNombreProductoURL, RutaLocal
} from '../componentes/funcionesEspeciales'
import { useParams } from 'react-router-dom';
import { Alert } from "react-bootstrap";
import moment from "moment";

function BuscaFactura({ agregarItemCarro }) {
    const [cargando, setCargando] = useState(false)
    const [datos, setDatos] = useState({
        ruc: '',
        tipo_documento: '',
        numero_comprobante: '',
        total_comprobante: 0,
        fecha_emision: moment().format("YYYY-MM-DD")
    })
    const manejadorDatos = (e) => {
        const { name, value } = e.target
        setDatos({
            ...datos,
            [name]: value
        })
    }
    const [resultado, setResultado] = useState({
        mostrar: false,
        estado: true,
        mensaje: '',
        enlace_pdf: '',
        enlace_xml: '',
        enlace_cdr: ''
    })
    const validaForm = () => {
        if (datos.ruc == "") {
            alert("Ingrese el RUC")
            return false
        }
        if (datos.tipo_documento == "") {
            alert("Ingrese el tipo de documento")
            return false
        }
        if (datos.numero_comprobante == "" || datos.numero_comprobante.split("-").length != 2) {
            alert("Ingrese numero de comprobante en formato XXXX-XXXX")
            return false
        }
        if (datos.total_comprobante == "") {
            alert("Ingrese el total del comprobante")
            return false
        }
        return true
    }
    const buscarComprobante = () => {
        if (!validaForm()) return
        setCargando(true)
        let serie = datos.numero_comprobante.split("-")[0]
        let numero = datos.numero_comprobante.split("-")[1]
        ConsultaData('?/web/buscarComprobante/&ruc=' + datos.ruc + '&tipo_documento=' + datos.tipo_documento +
            '&serie=' + serie + '&numero=' + numero + '&total_comprobante=' + datos.total_comprobante).then(response => {
                setCargando(false)
                if (response) {
                    setResultado({
                        mostrar: true,
                        estado: response.response,
                        mensaje: response.mensaje,
                        id_venta: response.response ? response.data.id_venta : 0,
                        //enlace_pdf: response.solo_venta ? "-" : response.data.id_venta,
                        //enlace_pdf: response.data.id_venta,
                        enlace_pdf: response.response ? Ruta + "?/web/descargarPDF/" + response.data.id_venta : "#",
                        //enlace_xml: !response.response || response.solo_venta ? "-" : Ruta + "facturador/files/" + response.data.enlace_del_xml,
                        //enlace_cdr: !response.response || response.solo_venta ? "-" : Ruta + "facturador/files/R-" + response.data.enlace_del_cdr
                        enlace_xml: !response.response || response.solo_venta ? "-" : Ruta + "?/web/descargarXML/" + response.data.id_venta,
                        enlace_cdr: !response.response || response.solo_venta ? "-" : Ruta + "?/web/descargarCDR/" + response.data.id_venta
                    })
                }
            })
    }
    const descargarArchivo = (tipo, nombre_archivo) => {
        fetch(resultado["enlace_" + tipo])
            /*.then(resp => {
                if (!resp.ok) {
                    throw new Error('Hubo un error al descargar el archivo');
                }
                return resp.blob();
            })*/
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = nombre_archivo; // Debe ser reemplazado por el nombre que deseas para el archivo descargado.
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(() => alert('Hubo un error al descargar el archivo'));

    }
    //const [rucEmpresa, setRucEmpresa] = useState([])
    return (
        <div className=" py-5 container">
            <div className="row">
                <div className="col-md-5 col-lg-5 col-sm-12">
                    <div className="row">
                        <div className="col-md-12">
                            <label>RUC EMISOR</label>
                            <select name="ruc" value={datos.ruc} className="form form-control form-control-sm" onChange={manejadorDatos}>
                                <option value="" >Seleccione RUC</option>
                                <option value="20455411000" >20455411000</option>
                                <option value="20454190026" >20454190026</option>
                                <option value="20558142791" >20558142791</option>
                            </select>
                        </div>
                        <div className="col-md-12">
                            <label>Tipo Comprobante</label>
                            <div className="input-group">
                                <select name="tipo_documento" value={datos.tipo_documento} className="form form-control form-control-sm" onChange={manejadorDatos} >
                                    <option value="" >Seleccione Tipo </option>
                                    <option value="boleta" >Boleta</option>
                                    <option value="factura" >Factura</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label>Numero Comprobante</label>
                            <input name="numero_comprobante" value={datos.numero_comprobante} className="form form-control form-control-sm" onChange={manejadorDatos} placeholder="XXXX-XXXXX" />
                        </div>
                        <div className="col-md-12">
                            <label>Fecha Emision</label>
                            <input name="fecha_emision" value={datos.fecha_emision} type="date" className="form form-control form-control-sm" onChange={manejadorDatos} />
                        </div>
                        <div className="col-md-12">
                            <label>Total Comprobante</label>
                            <input name="total_comprobante" value={datos.total_comprobante} className="form form-control form-control-sm" onChange={manejadorDatos} />
                        </div>
                        <div className="col-md-12">
                            <br />
                            <button type="button" className="btn btn-sm btn-secondary" disabled={false} onClick={buscarComprobante}>BUSCAR</button>
                        </div>
                    </div>
                </div>
                <div className="col-md-7 col-sm-12 col-lg-7">
                    <h2 >Aquí podrá descargar sus Archivos </h2>
                    <br />
                    {cargando ? "Buscando comprbante" :
                        <>
                            {resultado.mostrar &&
                                <div>
                                    <Alert variant={resultado.estado ? "success" : "warning"}>
                                        {resultado.mensaje}
                                    </Alert>
                                    <div className="row">
                                        <hr />
                                        <div className="col-12">
                                            {resultado.enlace_pdf != "-" ? <a href={"#"} onClick={(e) => descargarArchivo("pdf", 'comprobante.pdf')} style={{ textDecoration: "underline" }}>Descargar PDF</a> : 'No encontrado'}
                                        </div>
                                        <hr />
                                        <div className="col-12">
                                            {resultado.enlace_xml != "-" ? <a href={"#"} onClick={(e) => descargarArchivo("xml", 'comprobante.xml')} style={{ textDecoration: "underline" }}>Descargar XML</a> : 'Procesando XML'}
                                        </div>
                                        <hr />
                                        <div className="col-12">
                                            {resultado.enlace_cdr != "-" ? <a href={"#"} onClick={(e) => descargarArchivo("cdr", 'comprobante.zip')} style={{ textDecoration: "underline" }}>Descargar CDR</a> : 'Procesando CDR'}
                                        </div>
                                    </div>
                                </div>
                            }
                        </>}
                </div>
            </div>

        </div >
    );
}

export default BuscaFactura;
